import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-contact-info]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-contact-info]').forEach((content) => {
    content.querySelectorAll('a').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        let clickText = e.target.querySelector(':not([data-au-icon])').innerText;
        clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

        const infoTitle = e.target
          .closest('[data-au-contact-info-block]')
          .querySelector('[data-au-contact-info-title]');

        const infoSubTitle = e.target
          .closest('[data-au-tab-content]')
          .querySelector('[data-au-contact-info-sub-title]');

        const infoMainTitle = e.target.closest('[data-au-contact-info]').querySelector('[data-au-title]');

        let titleText;

        if (infoTitle) {
          titleText = infoTitle.innerText;
        } else if (infoSubTitle) {
          titleText = infoSubTitle.innerText;
        } else if (infoMainTitle) {
          titleText = infoMainTitle.innerText;
        } else {
          titleText = '';
        }

        titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

        let content_type;

        if (e.target.href.indexOf('mailto') > -1) {
          content_type = 'clickEmail';
        } else if (e.target.href.indexOf('tel') > -1) {
          content_type = 'clickTelefono';
        } else {
          content_type = 'clickEnlace';
        }
        const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

        window.dataLayer.push({
          event: 'navigation',
          content_type,
          item_id,
        });
      });
    });
  });
}

export default { init };
